import $ from "jquery"
import messageResource from "../messageResource";
import {addClass, removeClass, hasClass} from "../atBrowserUtils";

export default function FilterWordsField () {}

FilterWordsField.prototype.initAndRender = function ( onChangeCallback, renderTo, placeHolderTextKey, clearCallback ) {
    var self = this;
    this.callback = onChangeCallback;
    var innerTable = document.createElement("table");
    innerTable.className = "filterWordsField";
    innerTable.tabIndex = -1;
    var innerTBody = document.createElement("tbody");
    var innerTr = document.createElement("tr");
    var inputInnerTd = document.createElement("td");
    var input = document.createElement("input");
    input.type = "text";
    input.maxLength = 100;
    $(input).addClass("filterFieldInput");
    this.alwaysPaintFocusedBorder = false;
    this.showPlaceholder = false;
    if (placeHolderTextKey)
    {
        this.showPlaceholder = true;
        $( input ).attr( 'placeholder', messageResource.getMessage(placeHolderTextKey ) );
        $( input ).addClass('inputFieldWithPlaceholder');
        $( input ).placeholder();
    }
    var clearTd = document.createElement("td");
    var clearDiv = document.createElement("div");
    clearTd.className = "clearFilterButton";

    innerTable.appendChild(innerTBody);
    innerTBody.appendChild(innerTr);
    innerTr.appendChild(inputInnerTd);
    innerTr.appendChild(clearTd);
    inputInnerTd.appendChild(input);
    clearTd.appendChild(clearDiv);

    this.inputElement = input;
    this.clearButton = clearDiv;
    this.element = innerTable;

    $(innerTable).focusin( function () { addClass(self.element, "inputFocused"); } );
    $(innerTable).focusout( function () { self._deactivateBorderFocus(); } );
    $(innerTable).click( function ()
                         {
                             $(self.inputElement).focus();
                             addClass(self.element, "inputFocused");
                         } );

    this.clearFn = function()
    {
        self.inputElement.value = "";
        addClass(self.clearButton, "inactiveButton" );
        $(self.clearButton).off( "click" );
        if (clearCallback)
            clearCallback();
    };
    $(input).keyup( function( event )
                    {
                        onChangeCallback( event );
                        if ( self.inputElement.value != "" )
                        {
                            if( hasClass( self.clearButton, "inactiveButton" ) )
                            {
                                removeClass(self.clearButton, "inactiveButton" );
                                $(self.clearButton).click( self.clearFn );
                            }
                        }
                        else if ( !hasClass( self.clearButton, "inactiveButton" ) )
                        {
                            addClass(self.clearButton, "inactiveButton" );
                            $(self.clearButton).off( "click" );
                        }
                    }  );

    // fix for bug 54142
    $(input).keydown( function( event ) { event.stopPropagation(); });
    $(input).keypress( function( event ) { event.stopPropagation(); });

    addClass(self.clearButton, "inactiveButton" );

    if (renderTo)
        renderTo.appendChild(this.element);

    return this;
};

FilterWordsField.prototype.getElement = function () {
    return this.element;
};

FilterWordsField.prototype.getSearchString = function ()
{
    return this.getInputElementValue();
};

FilterWordsField.prototype.isInputFieldActive = function ()
{
    return $(this.inputElement).is(":focus") || this.getInputElementValue().length != 0;
};

FilterWordsField.prototype.getInputElementValue = function () {
    return this.showPlaceholder ? $(this.inputElement).pVal() : this.inputElement.value;
};

FilterWordsField.prototype.setInputValue = function (value) {
    this.inputElement.value = value;
    if ( value )
    {
        $(this.clearButton).click( this.clearFn );
        removeClass( this.clearButton, "inactiveButton" );
    }
    else
    {
        $(this.clearButton).off( "click" );
        addClass( this.clearButton, "inactiveButton" );
    }
};

FilterWordsField.prototype.clearInputValue = function( useClearCallback )
{
    this.setInputValue( "" );
    if ( useClearCallback && this.clearFn )
        this.clearFn();
};

FilterWordsField.prototype.getInnerInputElement = function () {
    return this.inputElement;
};

FilterWordsField.prototype.activateAndFocus = function()
{
    this.inputElement.focus();
};

FilterWordsField.prototype.alwaysPaintFocusedBorderIfInputHasValue = function( value )
{
    this.alwaysPaintFocusedBorder = value;
};

FilterWordsField.prototype._deactivateBorderFocus = function()
{
    if ( !this.alwaysPaintFocusedBorder || !this.inputElement.value )
        removeClass(this.element, "inputFocused" );
};

FilterWordsField.prototype.isInputFieldActive = function ()
{
    return $(this.inputElement).is(":focus") || this.getInputElementValue().length != 0;
};

FilterWordsField.prototype.focusOutFromInput = function ()
{
    $(this.inputElement).focusout();
};


// WEBPACK FOOTER //
// ./web/js/controls/FilterWordsField.js